import { __assign, __awaiter, __generator } from "tslib";
import { logger } from '../logger';
import { registerDynamics365Marketing, registerHTMLPlugin, registerHubspotPlugin, registerIframePlugin, } from './plugins';
import { identifyFromEmail } from './utils';
import { registerDrift } from './plugins/Drift';
import { registerQualified } from './plugins/Qualified';
import { registerSleeknote } from './plugins/Sleeknote';
var DEFAULT_OPTIONS = {
    shouldHash: false,
    identifyFromEmail: true,
};
export function registerFormTracking(analytics, partialOptions) {
    return __awaiter(this, void 0, void 0, function () {
        var options;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    options = __assign(__assign({}, DEFAULT_OPTIONS), partialOptions);
                    if (!options.identifyFromEmail) return [3 /*break*/, 2];
                    return [4 /*yield*/, identifyFromEmail(analytics, options.shouldHash || false)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if (!options.drift &&
                        !options.dynamics365Marketing &&
                        !options.html &&
                        !options.iframeForm &&
                        !options.hubspot &&
                        !options.sleeknote) {
                        logger.error("'form-tracking' is enabled but no forms to identify have been specified. This means there is likely an error in your script setup.");
                    }
                    if (options.drift) {
                        registerDrift(analytics, options);
                        logger.debug("Drift form-tracking enabled");
                    }
                    if (options.dynamics365Marketing) {
                        registerDynamics365Marketing(analytics, options);
                        logger.debug("Dynamics 365 Marketing form-tracking enabled");
                    }
                    if (options.html) {
                        registerHTMLPlugin(analytics, options);
                        logger.debug("HTML form-tracking enabled");
                    }
                    if (options.iframeForm) {
                        registerIframePlugin(analytics, options);
                        logger.debug("Iframe form-tracking enabled");
                    }
                    if (options.hubspot) {
                        registerHubspotPlugin(analytics, options);
                        logger.debug("Hubspot form-tracking enabled");
                    }
                    if (options.sleeknote) {
                        registerSleeknote(analytics, options);
                        logger.debug("Sleeknote form-tracking enabled");
                    }
                    if (options.qualified) {
                        registerQualified(analytics);
                        logger.debug('Qualified chat conversation tracking enabled');
                    }
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=FormTracking.js.map